// extracted by mini-css-extract-plugin
module.exports = {"base":"organism3-m__base__1dwYa"};